import { ReactNode } from 'react'

import Widget from 'common/components/Widget'
import { Alert } from 'common/icons'

type Props = {
  title: string
  children: ReactNode
}

const GuidanceWidget = ({ title, children }: Props) => {
  return (
    <Widget type="basic" className="bg-lightBlue-50 border-lightBlue-200">
      <div className="text-lightBlue-800 font-medium text-xl mr-4 capitalize-first">
        <Alert isDefaultColor={false} />
        <div className="mt-4">{title}</div>
        <div className="text-lightBlue-600 text-sm font-normal mt-4">
          {children}
        </div>
      </div>
    </Widget>
  )
}

export default GuidanceWidget
